<template>
  <v-row>
    <v-col class="d-flex" cols="12">
      <GGSeal />
    </v-col>
  </v-row>
</template>

<script>
import GGSeal from '@/components/Profile/GGSeal'

export default {
  name: 'ProfileGGSeal',
  components: {
    GGSeal
  }
}
</script>
